<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><i class="el-icon-lx-calendar" /> 生产管理</el-breadcrumb-item>
        <el-breadcrumb-item>生产信息</el-breadcrumb-item>
        <el-breadcrumb-item>质检管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-form :inline="true" size="small" label-width="100px">
        <el-form-item label="默认质检员">
          <el-input v-model="defaults.qcInspector" clearable style="width:220px" />
        </el-form-item>
        <el-form-item label="默认质检结果">
          <el-input v-model="defaults.qcResult" clearable style="width:220px" />
        </el-form-item>
        <el-form-item>
          <el-button :loading="defaultSaving" type="primary" @click="saveDefaultConfig">保存默认值</el-button>
          <el-button @click="loadDefaultConfig">刷新</el-button>
        </el-form-item>
      </el-form>

      <el-divider />

      <!-- 主列表 -->
      <div class="handle-box">
        <el-form :inline="true" size="small" @keyup.enter.native="loadMainList">
          <el-form-item label="工单号">
            <el-input v-model="mainQuery.orderno" clearable placeholder="模糊" style="width:150px" />
          </el-form-item>
          <el-form-item label="批次">
            <el-input v-model="mainQuery.batchno" clearable placeholder="模糊" style="width:140px" />
          </el-form-item>
          <el-form-item label="产品内码">
            <el-input v-model="mainQuery.product_code" clearable placeholder="模糊" style="width:140px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="loadMainList">搜索</el-button>
            <el-button @click="resetMainQuery">重置</el-button>
            <el-button type="success" @click="openAddDialog">增加质检信息</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table v-loading="mainLoading" :data="mainList" border stripe size="small" style="width:100%">
        <el-table-column prop="orderno" label="工单号" min-width="120" />
        <el-table-column label="产品" min-width="180">
          <template slot-scope="s">{{ s.row.product_name }}（{{ s.row.product_code }}）</template>
        </el-table-column>
        <el-table-column prop="batchno" label="批次" width="120" show-overflow-tooltip />
        <el-table-column prop="line_no" label="行号" width="60" />
        <el-table-column prop="qcInspector" label="质检员" width="100" />
        <el-table-column prop="qcResult" label="质检结果" min-width="100" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="s">
            <el-button type="text" size="small" @click="openEdit(s.row)">修改</el-button>
            <el-button type="text" size="small" style="color:#f56c6c" @click="onDeleteRow(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top:12px"
        background
        layout="total, prev, pager, next, sizes"
        :total="mainTotal"
        :page-sizes="[10,20,50]"
        :page-size.sync="mainQuery.pageSize"
        :current-page.sync="mainQuery.pageIndex"
        @size-change="loadMainList"
        @current-change="loadMainList"
      />

      <!-- 大弹窗：新增 -->
      <el-dialog title="增加质检信息" :visible.sync="addVisible" width="820px" top="8vh" :close-on-click-modal="false" @closed="resetAddDialog">
        <el-form :inline="true" size="small" @submit.native.prevent>
          <el-form-item label="批次">
            <el-input v-model="addForm.batchno" clearable placeholder="必填" style="width:160px" />
          </el-form-item>
          <el-form-item label="产品内码">
            <el-input v-model="addForm.product_code" clearable placeholder="必填" style="width:180px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchAddCandidates">查询工单</el-button>
          </el-form-item>
        </el-form>
        <el-row :gutter="12" style="margin-bottom:10px">
          <el-col :span="8">
            <el-input v-model="addForm.qcInspector" placeholder="质检员" clearable />
          </el-col>
          <el-col :span="8">
            <el-input v-model="addForm.qcResult" placeholder="质检结果" clearable />
          </el-col>
        </el-row>
        <el-table ref="addTable" :data="addCandidates" border size="small" max-height="360" @selection-change="rows => addSelected = rows">
          <el-table-column type="selection" width="45" />
          <el-table-column prop="orderno" label="工单号" min-width="120" />
          <el-table-column prop="product_code" label="产品内码" width="100" />
          <el-table-column prop="product_name" label="产品" min-width="140" show-overflow-tooltip />
          <el-table-column prop="batchno" label="批次" width="120" />
          <el-table-column prop="line_no" label="行号" width="60" />
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addVisible = false">取 消</el-button>
          <el-button
            type="primary"
            :disabled="!addSelected.length || !addForm.qcInspector || !addForm.qcResult"
            @click="saveAddDialog"
          >
            设 置
          </el-button>
        </span>
      </el-dialog>

      <!-- 修改 -->
      <el-dialog title="修改质检信息" :visible.sync="editVisible" width="520px" :close-on-click-modal="false">
        <el-form v-if="editRow" label-width="110px" size="small">
          <el-form-item label="工单号"><span>{{ editRow.orderno }}</span></el-form-item>
          <el-form-item label="产品"><span>{{ editRow.product_name }}（{{ editRow.product_code }}）</span></el-form-item>
          <el-form-item label="批次"><span>{{ editRow.batchno }}</span></el-form-item>
          <el-form-item label="行号"><span>{{ editRow.line_no }}</span></el-form-item>
          <el-form-item label="质检员">
            <el-input v-model="editForm.qcInspector" />
          </el-form-item>
          <el-form-item label="质检结果">
            <el-input v-model="editForm.qcResult" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">保 存</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  workorderQcPageList,
  workorderQcSearchCandidates,
  workorderQcBatchSave,
  workorderQcSingleSave,
  workorderQcClear,
  produceMtConfigGet,
  produceMtConfigEdit
} from '@/api/plant'

const QC_DEFAULT_INSPECTOR_KEY = 'qc_default_inspector'
const QC_DEFAULT_RESULT_KEY = 'qc_default_result'

export default {
  name: 'QualityInspectionManage',
  data() {
    return {
      defaultSaving: false,
      defaults: {
        qcInspector: '',
        qcResult: ''
      },
      mainLoading: false,
      mainList: [],
      mainTotal: 0,
      mainQuery: {
        orderno: '',
        batchno: '',
        product_code: '',
        pageIndex: 1,
        pageSize: 20
      },
      addVisible: false,
      addForm: { batchno: '', product_code: '', qcInspector: '', qcResult: '' },
      addCandidates: [],
      addSelected: [],
      editVisible: false,
      editRow: null,
      editForm: { qcInspector: '', qcResult: '' }
    }
  },
  mounted() {
    this.loadMainList()
    this.loadDefaultConfig()
  },
  methods: {
    loadDefaultConfig() {
      Promise.all([
        produceMtConfigGet(QC_DEFAULT_INSPECTOR_KEY),
        produceMtConfigGet(QC_DEFAULT_RESULT_KEY)
      ]).then(([inspectorRes, resultRes]) => {
        this.defaults.qcInspector = (inspectorRes.data && inspectorRes.data.conf_value) || ''
        this.defaults.qcResult = (resultRes.data && resultRes.data.conf_value) || ''
      }).catch(() => {
        this.$message.warning('默认值配置读取失败，请确认配置表中已存在对应 key')
      })
    },
    saveDefaultConfig() {
      this.defaultSaving = true
      Promise.all([
        produceMtConfigEdit(QC_DEFAULT_INSPECTOR_KEY, this.defaults.qcInspector || ''),
        produceMtConfigEdit(QC_DEFAULT_RESULT_KEY, this.defaults.qcResult || '')
      ]).then(() => {
        this.$message.success('默认值保存成功')
      }).catch(() => {
        this.$message.error('默认值保存失败，请确认 key 已存在且有编辑权限')
      }).finally(() => {
        this.defaultSaving = false
      })
    },
    loadMainList() {
      this.mainLoading = true
      workorderQcPageList({ ...this.mainQuery })
        .then(res => {
          const d = res.data || {}
          const rows = d.data || []
          this.mainList = rows.map(r => ({
            ...r,
            qcInspector: r.qcInspector != null ? r.qcInspector : r.QcInspector,
            qcResult: r.qcResult != null ? r.qcResult : r.QcResult
          }))
          this.mainTotal = d.total_count || 0
        })
        .finally(() => { this.mainLoading = false })
    },
    resetMainQuery() {
      this.mainQuery = { orderno: '', batchno: '', product_code: '', pageIndex: 1, pageSize: 20 }
      this.loadMainList()
    },
    openAddDialog() {
      this.addVisible = true
      this.addForm = {
        batchno: '',
        product_code: '',
        qcInspector: this.defaults.qcInspector || '',
        qcResult: this.defaults.qcResult || ''
      }
      this.addCandidates = []
      this.addSelected = []
    },
    resetAddDialog() {
      this.addCandidates = []
      this.addSelected = []
    },
    searchAddCandidates() {
      if (!this.addForm.batchno || !this.addForm.product_code) {
        this.$message.warning('请填写批次与产品内码')
        return
      }
      workorderQcSearchCandidates({
        batchno: this.addForm.batchno,
        product_code: this.addForm.product_code
      }).then(res => {
        this.addCandidates = res.data || []
      })
    },
    saveAddDialog() {
      if (!this.addSelected.length) {
        this.$message.warning('请至少选择一项工单')
        return
      }
      if (!this.addForm.qcInspector || !this.addForm.qcResult) {
        this.$message.warning('请填写质检员与质检结果')
        return
      }
      workorderQcBatchSave({
        ids: this.addSelected.map(r => r.id),
        qcInspector: this.addForm.qcInspector,
        qcResult: this.addForm.qcResult
      }).then(() => {
        this.$message.success('设置成功')
        this.addVisible = false
        this.loadMainList()
      })
    },
    openEdit(row) {
      this.editRow = row
      this.editForm = {
        qcInspector: row.qcInspector || '',
        qcResult: row.qcResult || ''
      }
      this.editVisible = true
    },
    saveEdit() {
      workorderQcSingleSave({
        id: this.editRow.id,
        qcInspector: this.editForm.qcInspector,
        qcResult: this.editForm.qcResult
      }).then(() => {
        this.$message.success('保存成功')
        this.editVisible = false
        this.loadMainList()
      })
    },
    onDeleteRow(row) {
      this.$confirm('将清空该工单的质检员与质检结果，是否继续？', '提示', { type: 'warning' })
        .then(() => workorderQcClear({ id: row.id }))
        .then(() => {
          this.$message.success('已删除配置')
          this.loadMainList()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
